module.exports = __webpack_public_path__ + "static/media/linkedin.039be55a.svg";